<template>
	<div class="content">
		<!-- 背景图片 -->
		<div class="login_bg"></div>
		<!-- 注册表单 -->
		<div class="login_form">
			<div class="top">
				<Logo></Logo>
				<div class="goLogin">
					已有账号，<span @click="goLogin">立即登录&nbsp;&nbsp;></span>
				</div>
			</div>
			<div class="down">
				<!-- <Steps :currentStep="currentStep" :totalSteps="totalSteps" :stepsLabel="stepsLabel" @change="onChange" /> -->
				<div class="step">
					<div class="step_item" :class="{current_step: currentStep==1}" @click="onChange(1)">
						<div class="serial_number">1</div>
						<span>索道云账号注册</span>
						<span class="el-icon-arrow-right"></span>
					</div>
					<div class="step_item" :class="{current_step: currentStep==2}" @click="onChange(2)">
						<div class="serial_number">2</div>
						<span>个人认证</span>
						<span class="el-icon-arrow-right"></span>
					</div>
					<div class="step_item" :class="{current_step: currentStep==3}" @click="onChange(3)">
						<div class="serial_number">3</div>
						<span>企业认证</span>
					</div>
				</div>
				<!-- 注册账号 -->
				<div class="infoForm" v-if="currentStep == 1">
					<el-form ref="firstStep" :rules="rules" :model="member">
						<el-form-item prop="username">
							<div class="icon">*</div>
							<el-input 
								v-model="member.username" 
								:readonly='actReadonly' 
								autocomplete="new-password"
								placeholder="用户名"
								@focus="changeActReadonly(false)"
								@blur="changeActReadonly(true)"/>
						</el-form-item>
						<el-form-item prop="password">
							<div class="icon">*</div>
							<el-input v-model="member.password" show-password autocomplete="new-password" placeholder="密码"/>
						</el-form-item>
						<el-form-item prop="confirmPassword">
							<div class="icon">*</div>
							<el-input type="password" v-model="member.confirmPassword" show-password placeholder="确认密码"/>
						</el-form-item>
					  <el-form-item prop="phone">
							<div class="icon">*</div>
							<el-input v-model="member.phone" @blur="validatePhone" placeholder="手机号"/>
					  </el-form-item>
						<el-form-item prop="verificationCode">
							<div class="icon">*</div>
							<el-input 
								v-model="member.verificationCode"
								placeholder="短信验证码"/>
							<el-button
								class="code"
								type="primary"
								plain
								@click="getCode"
								:disabled="codeBtnDisabled">
								{{ buttonName }}
							</el-button>
						</el-form-item>
						<el-form-item prop="email">
							<div class="icon">*</div>
							<el-input v-model="member.email" placeholder="邮箱"/>
						</el-form-item>
						<el-form-item prop="authImg" ref="authImg">
							<div class="icon">*</div>
							<div>企业授权书：</div>
							<div class="image">
								<div class="upload">
									<div @click="changeFlag('authImg')">
										<el-upload
											class="avatar-uploader"
											action="string" 
											:data="{flag:this.imageFlag}"
											:show-file-list="false"
											:http-request="uploadImg"
											:before-upload="beforeAvatarUpload">
											<img v-if="member.authImg" :src="member.authImg" class="avatar">
											<div v-else class="beforeUpload">
												<el-icon class="el-icon-plus avatar-uploader-icon"><Plus /></el-icon>
												<span class="text">上传图片</span>
											</div>
										</el-upload>
									</div>
									<div class="upload_template" @click="downloadTemplate">下载模板</div>
								</div>
								<span class="tip">格式要求jpg、jpeg、png，不超过2MB</span>
							</div>
						</el-form-item>
					</el-form>
					<div class="nextButton">
						<div class="term">
							<input type="checkbox" v-model="isAccept">
							阅读并接受
							<router-link to="/register/argeement" target="_blank">《用户注册与隐私保护服务协议》</router-link>
						</div>
						<el-button type="primary" @click="goNextStep(2)">下一步</el-button>
					</div>
				</div>
				<!-- 个人认证 -->
				<div class="infoForm" v-else-if="currentStep == 2">
					<el-form :model="member">
					    <el-form-item>
							<el-input v-model="member.memberName" placeholder="真实姓名"/>
					    </el-form-item>
						<el-form-item>
							<el-input v-model="member.memberIDCard" placeholder="身份证号"/>
						</el-form-item>
						<el-form-item>
							<div>个人身份证照片：</div>
							<div class="image">
								<div class="upload">
									<div @click="changeFlag('memberFIDCardImg')" v-loading="idCardLoading">
										<el-upload 
											class="avatar-uploader"
											action="string" 
											:data="{flag:this.imageFlag}"
											:show-file-list="false"
											:http-request="uploadImg"
											:before-upload="beforeAvatarUpload">
											<img v-if="member.memberFIDCardImg" :src="member.memberFIDCardImg" class="avatar">
											<div v-else class="beforeUpload">
												<el-icon class="el-icon-plus avatar-uploader-icon"><Plus /></el-icon>
												<span class="text">人像面</span>
											</div>
										</el-upload>
									</div>
									<div @click="changeFlag('memberBIDCardImg')">
										<el-upload 
											class="avatar-uploader"
											action="string" 
											:data="{flag:this.imageFlag}"
											:show-file-list="false"
											:http-request="uploadImg"
											:before-upload="beforeAvatarUpload">
											<img v-if="member.memberBIDCardImg" :src="member.memberBIDCardImg" class="avatar">
											<div v-else class="beforeUpload">
												<el-icon class="el-icon-plus avatar-uploader-icon"><Plus /></el-icon>
												<span class="text">国徽面</span>
											</div>
										</el-upload>
									</div>
								</div>
								<span class="tip">请提供原件照片，格式要求jpg、jpeg、png，不超过2MB</span>
							</div>
						</el-form-item>
					</el-form>
					<div class="nextButton">
						<!-- :class="{first:!isAccept,second:isAccept}" -->
						<el-button type="primary" @click="goNextStep(3)">下一步</el-button>
					</div>
				</div>
				<!-- 企业认证 -->
				<div class="infoForm" v-else-if="currentStep==3">
					<el-form :model="member">
					    <el-form-item>
							<el-input v-model="member.companyName" placeholder="企业名称"/>
					    </el-form-item>
						<el-form-item>
							<el-input v-model="member.companyCode" placeholder="统一社会信用代码"/>
						</el-form-item>
						<el-form-item>
							<el-input v-model="member.legalName" placeholder="法定代表人真实姓名"/>
						</el-form-item>
						<el-form-item>
							<el-input v-model="member.legalIDCard" placeholder="法定代表人身份证号"/>
						</el-form-item>
						<el-form-item>
							<div class="label">法人身份证照片：</div>
							<div class="image">
								<div class="upload">
									<div @click="changeFlag('legalFIDCardImg')" v-loading="legalLoading">
										<el-upload 
											class="avatar-uploader"
											action="string" 
											:data="{flag:this.imageFlag}"
											:show-file-list="false"
											:http-request="uploadImg"
											:before-upload="beforeAvatarUpload">
											<img v-if="member.legalFIDCardImg" :src="member.legalFIDCardImg" class="avatar">
											<div v-else class="beforeUpload">
												<el-icon class="el-icon-plus avatar-uploader-icon"><Plus /></el-icon>
												<span class="text">人像面</span>
											</div>
										</el-upload>
									</div>
									<div @click="changeFlag('legalBIDCardImg')">
										<el-upload 
											class="avatar-uploader"
											action="string" 
											:data="{flag:this.imageFlag}"
											:show-file-list="false"
											:http-request="uploadImg"
											:before-upload="beforeAvatarUpload">
											<img v-if="member.legalBIDCardImg" :src="member.legalBIDCardImg" class="avatar">
											<div v-else class="beforeUpload">
												<el-icon class="el-icon-plus avatar-uploader-icon"><Plus /></el-icon>
												<span class="text">国徽面</span>
											</div>
										</el-upload>
									</div>
								</div>
								<span class="tip">请提供原件照片，格式要求jpg、jpeg、png，不超过2MB</span>
							</div>
						</el-form-item>
						<el-form-item>
							<div class="label">企业营业执照照片：</div>
							<div class="image">
								<div @click="changeFlag('companyLicenseImg')" v-loading="companyLoading">
									<el-upload 
										class="avatar-uploader"
										action="string" 
										:data="{flag:this.imageFlag}"
										:show-file-list="false"
										:http-request="uploadImg"
										:before-upload="beforeAvatarUpload">
										<img v-if="member.companyLicenseImg" :src="member.companyLicenseImg" class="avatar">
										<div v-else class="beforeUpload">
											<el-icon class="el-icon-plus avatar-uploader-icon"><Plus /></el-icon>
											<span class="text">上传图片</span>
										</div>
									</el-upload>
								</div>
								<span class="tip">格式要求jpg、png，不超过2MB</span>
							</div>
						</el-form-item>
					</el-form>
					<div class="nextButton">
						<el-button type="primary" @click="register">完成注册</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {obsUploadImage, identifyIDCard, identifyLicense} from '@/api/resource.js'
	import {getVerificationCode,validVerificationCode} from '@/api/sms.js'
	import {addMember} from '@/api/user.js'
	import Logo from '@/components/common/logo.vue'
	// import Steps from '@/components/common/steps.vue'
	import { validUsername,validPassword,validPhone,validEmail } from '@/utils/validate.js'
	export default {
		components:{
			Logo,
			// Steps
		},
	    data() {
				const validateConfirmPwd = (rule, value, callback) => {
					if (value == '') {
						callback(new Error('请再次输入密码'));
					} else if (value != this.member.password) {
						callback(new Error('两次输入密码不一致'));
					} else {
						callback()
					}
				}
				const validateCode = (rule, value, callback) => {
					if (value == '') {
						callback(new Error('请输入验证码'))
					} else if (value != this.correctCode) {
						callback(new Error('验证码有误或已过期'))
					} else {
						callback()
					}
				}
	      return {
					currentStep: 1,
					// totalSteps: 3,
					// stepsLabel: ['注册账号', '个人认证', '企业认证'],
					codeStatus: '0',//验证码用途标识，0表示注册
					countDown: 60,//倒计时
					buttonName: '发送验证码',//按钮初始化文字
					codeBtnDisabled: true,//是否禁用发生验证码按钮
					phoneChecked: false,
					correctCode: '',//正确的验证码
					actReadonly: true,
					// pwdReadonly: true,
					//表单
					member: {
						username: '',
						password: '',
						confirmPassword: '',
						phone: '',
						verificationCode: '',
						email: '',
						authImg: '',
						memberName: '',
						memberIDCard: '',
						companyName: '',
						companyCode: '',
						legalName: '',
						legalIDCard: '',
						memberFIDCardImg: '',
						memberBIDCardImg: '',
						legalFIDCardImg: '',
						legalBIDCardImg: '',
						companyLicenseImg: '',
						personStatus: '0',
						companyStatus: '0',
					},
					rules: {
						username: [
              { required: true,  message: '请输入用户名', trigger: 'blur' }, 
            ],
						password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
                { pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/, message: '至少8个字符，至少包含1个字母，1个数字和1个特殊字符', trigger: 'blur' }
            ],
						confirmPassword: [
							{ required: true, trigger: 'blur', validator: validateConfirmPwd }
						],
						phone: [
                { required: true, message: '请输入手机号', trigger: 'blur' },
                { pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
            ],
						verificationCode: [
							{ required: true, trigger: 'blur', validator: validateCode }
						],
						email: [
              { required: true, message: '请输入邮箱', trigger: 'blur' },
              { pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: '请输入正确的邮箱地址', trigger: 'blur' }
            ],
						authImg: [
							{ required: true, message: '请上传企业授权书', trigger: 'change'}
						],
					},
					isAccept: false,//是否勾选接受用户协议
					//图片加载
					idCardLoading: false,
					legalLoading: false,
					companyLoading: false,
					companyLegalState: '0',//企业法人认证状态
					companyState: '0',//企业营业执照认证状态
					imageFlag: '',
	      }
	    },
			watch: {
				'member.phone': function(val) {
					if (val == '') {
            this.codeBtnDisabled = true;
          } else {
            this.codeBtnDisabled = false;
          }
				}
			},
		methods:{
			//点击步骤条切换step
			onChange (index) {
				if(this.currentStep == 1) {
					return;
				} else if (this.currentStep == 2) {
					if(index == 1) {
						this.currentStep = index;
					} else {
						return;
					}
				} else {
					this.currentStep = index;
				}
			},
			//点击 下一步
			goNextStep(val) {
				if (val == 2) {
					this.$refs['firstStep'].validate((valid) => {
        	  if (valid) {
							if (this.isAccept) {
								this.currentStep = val;
							} else {
								alert('请先阅读《用户注册与隐私保护协议》！')
							}
        	  } else {
        	    return false;
        	  }
        	});
				} else {
					this.currentStep = val;
				}
			},
			//验证手机号是否正确
			validatePhone() {
				this.$refs['firstStep'].validateField('phone', err => {
					if (err) {
						this.codeBtnDisabled = true;
						this.phoneChecked = false;
						return false;
					} else {
						this.codeBtnDisabled = false;
						this.phoneChecked = true;
					}
				})
			},
			//获取短信验证码
			getCode() {
				if (this.phoneChecked && !this.codeBtnDisabled) {
					this.codeBtnDisabled = true
					let maxNum = this.countDown
					let oldButtonName = this.buttonName
					this.buttonName = `${maxNum}s重新发送` //初始显示倒计时
					let codeCountDown = setInterval(() => {
					  let nowCountDown = maxNum--;
					  this.buttonName = `${nowCountDown}s重新发送`
					  if (nowCountDown == 0) {
						//倒计时结束
						this.buttonName = oldButtonName
						clearInterval(codeCountDown)
						this.codeBtnDisabled = false
					  }
					}, 1000)
					let param={
						phone:this.member.phone.trim(),
						status:this.codeStatus,
					}
					getVerificationCode(param).then(data => {
						this.$message.success("验证码发送成功！")
						this.getCorrectCode();
					}).catch(error => {
						this.$message.error(error)
					})
				} else {
					return;
				}
			},
			//获取正确的验证码
			getCorrectCode() {
				let param = {
					phone:this.member.phone.trim(),
					status:this.codeStatus,
				}
				validVerificationCode(param).then(data => {
					this.correctCode = data.data;
				}).catch(error => {
					this.$message.error(error);
				})
			},
			//解决账号输入框自动填充问题
			changeActReadonly(val) {
				this.actReadonly = val;
			},
			//解决密码输入框自动填充问题
			// changePwdReadonly(val){
			// 	this.pwdReadonly=val
			// },
			//图片上传之前的验证
			beforeAvatarUpload(file) {
				const isIMAGE =  (file.type === 'image/jpg') || (file.type === 'image/png') || (file.type === "image/jpeg")
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isIMAGE) {
					this.$message.error('上传文件只能是图片格式!')
				}
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isIMAGE && isLt2M ;
			},
			changeFlag(param){
				this.imageFlag = param
			},
			//上传图片
			uploadImg(param) {
				let flag = param.data.flag
				if(flag == 'memberFIDCardImg') {
					this.idCardLoading = true;
				} else if(flag == 'legalFIDCardImg') {
					this.legalLoading = true;
				} else if(flag=='companyLicenseImg') {
					this.companyLoading = true;
				}
				let formData = new FormData();
				formData.append("file", param.file)
				obsUploadImage(formData).then(data => {
					if(flag=='authImg'){
						this.member.authImg=data.data
						this.$refs.authImg.clearValidate();
					}else if(flag=='memberFIDCardImg'){
						this.member.memberFIDCardImg = data.data
						this.identifyIDCard(this.member.memberFIDCardImg, 0);
					}else if(flag=='memberBIDCardImg'){
						this.member.memberBIDCardImg=data.data
					}else if(flag=='legalBIDCardImg'){
						this.member.legalBIDCardImg=data.data
					}else if(flag=='legalFIDCardImg'){
						this.member.legalFIDCardImg=data.data
						this.identifyIDCard(this.member.legalFIDCardImg, 1);
					}else if(flag=='companyLicenseImg'){
						this.member.companyLicenseImg=data.data
						this.identifyLicense(this.member.companyLicenseImg);
					}
				}).catch(error => {
					this.$message.error(error)
				})
			},
			//身份证信息认证
			identifyIDCard(cardImgUrl, type) {
				let memberFIDCardImg = cardImgUrl;
				if (type == 0) {
					//个人认证
					let memberIDCard = this.member.memberIDCard;
					let memberName = this.member.memberName;
					identifyIDCard(memberFIDCardImg, memberIDCard, memberName).then(res => {
						// console.log('个人身份证信息认证---', res);
						if(res.data) {
							this.member.personStatus = '2'
						} else {
							this.member.personStatus = '1'
						}
						this.idCardLoading = false;//图片加载
					})
				} else {
					//企业法人认证
					let memberIDCard = this.member.legalIDCard;
					let memberName = this.member.legalName;
					identifyIDCard(memberFIDCardImg,memberIDCard,memberName).then(res => {
						// console.log('法人身份证信息认证---', res);
						if(res.data) {
							this.companyLegalState = '2'
							if(this.companyState == '2') {
								this.member.companyStatus = '2'
							} else if(this.companyState == '1') {
								this.member.companyStatus = '1'
							} else {
								this.member.companyStatus = '0'
							}
						} else {
							this.companyLegalState = '1'
							if(this.companyState == '0') {
								this.member.companyStatus = '0'
							} else {
								this.member.companyStatus = '1'
							}
						}
						this.legalLoading = false;//图片加载
					})
				}
			},
			//营业执照信息认证
			identifyLicense(cardImgUrl) {
				let LicenseImg = cardImgUrl;
				let companyCode = this.member.companyCode;
				let companyName = this.member.companyName;
				let legalName = this.member.legalName;
				identifyLicense(LicenseImg, companyCode, companyName, legalName).then(res => {
					// console.log('营业执照信息认证---', res);
					if(res.data) {
						this.companyState = '2'
						if(this.companyLegalState == '2') {
							this.member.companyStatus = '2'
						} else if(this.companyLegalState == '1') {
							this.member.companyStatus = '1'
						} else {
							this.member.companyStatus = '0'
						}
					} else {
						this.companyState = '1'
						if(this.companyLegalState == '0') {
							this.member.companyStatus = '0'
						} else {
							this.member.companyStatus = '1'
						}
					}
					this.companyLoading = false;//图片加载
				})
			},
			//立即注册
			register() {
				// console.log("用户信息",this.member)
				addMember(this.member).then(data => {
					this.$message.success("注册成功")
					this.$router.push({path: '/login'})
				}).catch(error => {
					this.$message.error(error)
				})
			},
			//下载模板
			downloadTemplate() {
				var a = document.createElement("a");
  			a.href = "/static/template.docx";
  			a.download = "授权书模板.docx";
  			a.style.display = "none";
  			document.body.appendChild(a); 
  			a.click();
  			a.remove();
			},
			goLogin() {
				this.$router.push({path:'/login'})
			},
		}
	}
</script>
<style  lang="scss">
	.infoForm {
		.el-form-item__content {
			display: flex;
			justify-content: flex-start;
			.icon{
				height: 40px;
				margin-right: 25px;
				color: #c32d2d;
				font-size: 24px;
				line-height: 50px;
			}
			.label{
				width: 150px;
			}
			.code{
				width: 240px;
				height: 40px;
				margin-left: 10px;
				margin-bottom: 0;
				// color: #bbbbbb;
				text-align: center;
				font-size: 16px;
				// background-color: #ececec;
				border-radius: 10px;
			}
			.code:hover {
				background-color: #5783ee;
			}
			.el-button--primary.is-plain.is-disabled {
				color: #bbb;
				background-color: #ececec;
			}
			.image{
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				margin-left: 25px;
				.upload{
					width: 260px;
					display: flex;
					justify-content: space-between;
				}
				.el-upload{
					width: 120px;
					height: 120px;
					line-height: 20px;
					background-color: #f7f7f7;
					border-radius: 10px;
					border: 2px dashed #e9e9e9;
					display: flex;
					flex-direction: column;
					justify-content: center;
					.beforeUpload{
						display: flex;
						flex-direction: column;
						justify-content: center;
					}
					.avatar{
						width: 120px;
						height: 120px;
					}
				}
				.upload_template {
					width: 122px;
					height: 35px;
					margin-top: 89px;
					color: #333;
					text-decoration: underline;
				}
				.upload_template:hover {
					color: #537EEE;
					cursor: pointer;
				}
				.tip{
					// max-width: 400px;
					color: #6e6e6e;
				}
			}
			.el-form-item__error{
				left: 40px;
			}
		}
		.el-button {
			width: 100%;
			height: 56px;
			border: none;
			margin-bottom: 50px;
			border-radius: 8px;	
			background-color: #5783ee;
			font-size: 20px;
			color: #fff;
		}
	}
</style>
<style lang="scss" scoped="scoped">
	.content{
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		position: absolute;
		min-width: 1200px;
		min-height: 900px;
		display: flex;
		justify-content: center;
		align-items: center;
		.login_bg{
			width:100%;
			height:100%;
			min-width: 1200px;
			zoom: 1;
			z-index:-10;
			top: 0;
			left: 0;
			position:fixed;
			background: url('../../assets/common/login_background.png') no-repeat;
			background-color: #fff;
			background-size: cover;
			-webkit-background-size: cover;
			-o-background-size: cover;
			background-position: center 0;
		}
		.login_form{
			width: 1000px;
			background-color: #FFFFFF;
			box-shadow: 0px 0px 20px 10px #d0d2d5;
			.top{
				height: 80px;
				padding: 0 30px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid #d4d4d4;
				.goLogin{
					span{
						color: #507df1;
					}
					span:hover{
						cursor: pointer;
					}
				}
			}
			.down{
				padding: 0px 220px;
				display: flex;
				flex-direction: column;
				.step {
					overflow: hidden;
					margin: 50px 0 30px 60px;
					.step_item {
						float: left;
						.serial_number {
							display: inline-block;
							width: 25px;
							height: 25px;
							margin-right: 10px;
							background-color: #AAA;
							font-size: 13px;
							color: #fff;
							text-align: center;
							line-height: 25px;
							border-radius: 50%;
						}
						span {
							font-size: 14px;
							color: #AAA;
						}
						.el-icon-arrow-right {
							font-size: 16px;
							margin: 0 20px;
						}
					}
					.step_item :hover {
						cursor: pointer;
					}
					.current_step {
						.serial_number {
							background-color: #537EEE;
						}
						span {
							color: #537EEE;
						}
					}
				}
				.nextButton{
					.term{
						text-align: center;
						margin-bottom: 15px;
						a{
							text-decoration: none;
							color: #456cff;
						}
						a:hover{
							opacity: 0.8;
						}
					}
				}
			}
		}
	}
</style>
